const NAMESPACE = "paymentReceipt";

const KEYS = {
    projectNumberHeader: "projectNumberHeader",
    paymentIntentMessage: "paymentIntentMessage",
    paymentIdHeader: "paymentIdHeader",
    paymentDetailsHeader: "paymentDetailsHeader",
    confirmationMessage: "confirmationMessage",
    paidByMessage: "paidByMessage",
    feeMessage: "feeMessage",
    baseAmountMessage: "baseAmountMessage",
    dateMessage: "dateMessage"
};

const MESSAGES = {
    [KEYS.projectNumberHeader]: {
        value: "Your Project Number is:",
        comment: "Message shows on modal after project submission"
    },
    [KEYS.paymentIntentMessage]: {
        value: "Intent of submitting payment outside of PowerClerk has been recorded.",
        comment: "Message to user that the payment has been recorded, but is being processed outside of PowerClerk"
    },
    [KEYS.paymentIdHeader]: {
        value: "Payment ID:",
        comment: "Label for the transaction number"
    },
    [KEYS.paymentDetailsHeader]: {
        value: "Payment Details",
        comment: "Header for the Payment Details section of the receipt"
    },
    [KEYS.confirmationMessage]: {
        value: "Confirmation has been sent to the following email address:",
        comment: "Header for the email the confirmation has been sent to"
    },
    [KEYS.paidByMessage]: {
        value: "Paid by: {payerName}",
        comment: "Label for the payer of the fee"
    },
    [KEYS.feeMessage]: {
        value: "Fee: {feeDescription}",
        comment: "Description of the fee payment is for"
    },
    [KEYS.baseAmountMessage]: {
        value: "Charge Amount: {feeAmount}",
        comment: "Amount of payment not including a transaction fee surcharge"
    },
    [KEYS.dateMessageDate]: {
        value: "Date: {paymentDate}",
        comment: "Date of payment"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
